import * as THREE from 'three'
import { acceleratedRaycast, computeBoundsTree, disposeBoundsTree, SAH } from 'three-mesh-bvh'

let patched = false

/**
 * Patches Three.js prototypes to enable BVH-accelerated raycasting.
 *
 * Must be imported and called exactly once before any Mesh is raycasted.
 * After install, any BufferGeometry that has had `computeBoundsTree()` called
 * will use the accelerated path via the patched `Mesh.prototype.raycast`.
 * Geometries without a bounds tree fall through to the default raycaster,
 * so this is safe to apply globally.
 */
export const installBvhRaycastPatch = (): void => {
  if (patched) return
  // three-mesh-bvh 0.9.x exposes `computeBoundsTree` with the broader
  // `GeometryBVH` return type while still augmenting `BufferGeometry.prototype`
  // with the narrower `MeshBVH` shape. The runtime is identical; the cast
  // bridges the library's own type drift. Re-evaluate when upstream aligns
  // its augmentation with the exported function.
  THREE.BufferGeometry.prototype.computeBoundsTree =
    computeBoundsTree as unknown as typeof THREE.BufferGeometry.prototype.computeBoundsTree
  THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree
  THREE.Mesh.prototype.raycast = acceleratedRaycast
  patched = true
}

export const BVH_SPLIT_STRATEGY = SAH
